import { evaluate, parseExpr } from '@scs/domain-engine';

/**
 * Evaluates what the user typed into a millimetre field: plain numbers ("818", "18,5") or simple
 * arithmetic ("800+18", "543-18", "1200/3", "2*18+4", "(600-36)/2"). Optional units: "80cm+18mm".
 * Uses the engine's restricted expression parser (no eval). Returns millimetres or null if invalid.
 */
export function evalMm(raw: string): number | null {
  const s = raw.trim().replace(/,/g, '.');
  if (!s || s.length > 100) return null;
  if (!/^[0-9+\-*/().\sacmn]+$/i.test(s)) return null;
  try {
    const v = evaluate(parseExpr(s.toLowerCase()), () => undefined);
    const mm = v.dim === 'length' ? v.value / 1000 : v.value;
    return Number.isFinite(mm) ? Math.round(mm * 1000) / 1000 : null;
  } catch {
    return null;
  }
}

/** True when the text is an expression rather than a single number (to show the result while typing). */
export function isExpression(raw: string): boolean {
  return /[+*/()]|\d\s*-|[a-z]/i.test(raw.trim().replace(/^-/, ''));
}
